import { Injectable } from '@angular/core';
import { Device } from '@capacitor/device';
import { APP_VERSION } from './app-version';

@Injectable({
  providedIn: 'root'
})
export class ClientInfoService {

  clientId = this.build('unknown', 'unknown');

  async init(): Promise<void> {
    try {
      const info = await Device.getInfo();
      this.clientId = this.build(info.operatingSystem, info.osVersion);
    } catch (error) {
      console.error('Device.getInfo error: ', error);
    }
  }

  private build(osType: string, osVersion: string): string {
    return `Keep-Kiosk/${APP_VERSION}/${osType || 'unknown'}/${osVersion || 'unknown'}`;
  }
}
